<template>
    <div>
        <b-navbar type="light" class="navbar-light theme-nav fixed-top" toggleable="lg" fixed="top"  >
            <div class="container">
                <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
                <b-navbar-brand class="navbar-brand"><router-link to="/"><img src="../assets/logo_new.png" alt="logo"></router-link></b-navbar-brand>
                <b-collapse class="default-nav"  is-nav id="nav_collapse">
                    <b-navbar-nav class="navbar-nav ml-auto" id="mymenu">
                        <b-nav-item to="/news">Мэдээ, мэдээлэл</b-nav-item>
                        <b-nav-item-dropdown text="Хууль эрх зүй">
                            <b-dropdown-item to="/law/2" >Хууль эрх зүй</b-dropdown-item>
                            <b-dropdown-item to="/law/1" >Салбарын хууль, эрх зүйн актууд</b-dropdown-item>
                        </b-nav-item-dropdown>
                        <b-nav-item  to="/tetgeleg">Тэтгэлэг олголт</b-nav-item>
                        <b-nav-item href="/auth/login" target="_blank" class="login_button">Нэвтрэх</b-nav-item>
                    </b-navbar-nav>
                </b-collapse>
            </div>
        </b-navbar>
    </div>
</template>

<script>
    export default {
        name: 'WebHeader',
        data () {
            return {

            }
        },

    }
</script>
